import { REPORTING_ACCOUNTS_SEARCH_PARAMS } from './useReportingAccounts';
import { REPORTING_BENCHMARKS_SEARCH_PARAMS } from './useReportingBenchmarks';
import { REPORTING_DATE_RANGE_SEARCH_PARAMS } from './useReportingDateRange';
import { REPORTING_INCLUDE_CLOSED_SEARCH_PARAMS } from './useReportingIncludeClosed';

// Carried by the Reporting tab link so clicking it keeps the chosen date range, account selection,
// closed-account toggle and benchmarks instead of resetting them.
export const REPORTING_FILTER_SEARCH_PARAMS = [
    ...REPORTING_DATE_RANGE_SEARCH_PARAMS,
    ...REPORTING_ACCOUNTS_SEARCH_PARAMS,
    ...REPORTING_INCLUDE_CLOSED_SEARCH_PARAMS,
    ...REPORTING_BENCHMARKS_SEARCH_PARAMS,
];
